
declare namespace Slick {
    export interface Column {
        filterValues?: object[];
    }
}

namespace Slick.Plugins {

    /*
     Based on SlickGrid Header Menu Plugin (https://github.com/mleibman/SlickGrid/blob/master/plugins/slick.headermenu.js)
     Based on SlickGrid Spreadsheet Plugins (https://github.com/danny-sg/slickgrid-spreadsheet-plugins/blob/master/ext.headerfilter.js)
     (Can't be used at the same time as the header menu plugin as it implements the dropdown in the same way)
    */

    export interface HeaderFiltersOptions {
        buttonImage?: string;
        useColumnFormatter?: boolean;
        getFilterValues?: (column: Slick.Column, callback: (values: object[]) => void) => void;  
        isFilterable?: (column: Slick.Column) => boolean;
    }

    export class HeaderFilters {

        private grid: Slick.Grid;
        private menu: JQuery;
        private handler: Slick.EventHandler;
        private options: HeaderFiltersOptions;
        private workingFilters: object[];
        private filterItems: object[];
        public onFilterApplied = new Slick.Event();
        public onCommand = new Slick.Event();

        constructor(options: HeaderFiltersOptions) {
            this.handler = new Slick.EventHandler();

            var defaults: HeaderFiltersOptions = {
                buttonImage: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAABGdBTUEAALGPC/xhBQAAAAlwSFlzAAALEQAACxEBf2RfkQAAABl0RVh0U29mdHdhcmUAcGFpbnQubmV0IDQuMC4yMfEgaZUAAACeSURBVDhPvdItDsIwGIfxAoZNAQaDmOEgXAIzsRvgCArNCRBcYAmeO+AQHGBuCWqOhYTP521SQsZI2yzhn/xE3+RxVU3WRoSJoz70OpjiiMxijzH0WhhhgzOeP+RIEOA9E6e4oBqdIFGIr0k8xA43mKjADLXR5wY44IEr1rBGZltIWGIuB9f9P1zgDu+whxW8Q1kXS8T65Tn5x6IypV7aOzNezxwrTQAAAABJRU5ErkJggg==",
                useColumnFormatter: true,
                getFilterValues: null
            };

            this.options = $.extend(true, {}, defaults, options);
            this.handleMenuItemClick = this.handleMenuItemClick.bind(this);
        }
        
        init(g: Slick.Grid) {
            
            this.grid = g;
            this.handler.subscribe(g.onHeaderCellRendered, this.handleHeaderCellRendered.bind(this))
                .subscribe(g.onBeforeHeaderCellDestroy, this.handleBeforeHeaderCellDestroy.bind(this))
                .subscribe(g.onClick, this.handleBodyMouseDown.bind(this))
                .subscribe(g.onColumnsResized, this.columnsResized.bind(this));

            g.setColumns(g.getColumns());

            $(document.body).bind("mousedown", this.handleBodyMouseDown = this.handleBodyMouseDown.bind(this));
        }

        destroy() {
            this.handler.unsubscribeAll();
            $(document.body).unbind("mousedown", this.handleBodyMouseDown);
        }

        private handleBodyMouseDown(e: any) {
            if (this.menu && this.menu[0] != e.target && !$.contains(this.menu[0], e.target)) {
                this.hideMenu();
            }
        }

        private hideMenu() {
            if (this.menu) {
                this.menu.remove();
                this.menu = null;
            }
        }

        private handleHeaderCellRendered(e: any, args: any) {
            var column = args.column;

            if (this.options.isFilterable != null &&
                !this.options.isFilterable(column))
                return;

            var $el = $("<div></div>")
                .addClass("slick-header-menubutton")
                .data("column", column);

            if (this.options.buttonImage) {
                $el.css("background-image", "url(" + this.options.buttonImage + ")");
            }

            $(args.node).addClass('has-header-menubutton');
            $el.on("click", e => {
                e.stopPropagation();
                this.showFilter(e);
            }).appendTo(args.node);
        }

        private handleBeforeHeaderCellDestroy(e: any, args: any) {
            $(args.node)
                .find(".slick-header-menubutton")
                .remove();
        }

        private addMenuItem(menu: JQuery, columnDef: Slick.Column, title: string, command: string, image: string) {
            var $item = $("<div class='slick-header-menuitem'>")
                .data("command", command)
                .data("column", columnDef)
                .bind("click", this.handleMenuItemClick)
                .appendTo(menu);

            var $icon = $("<div class='slick-header-menuicon'>")
                .appendTo($item);

            if (image) {
                $icon.css("background-image", "url(" + image + ")");
            }

            $("<span class='slick-header-menucontent'>")
                 .text(title)
                 .appendTo($item);
        }

        private addMenuInput(menu: JQuery, columnDef: Slick.Column) {
            $("<input class='input' placeholder='"
                + (Q.tryGetText("Site.HeaderFiltersMixin.Search") || "Search")
                + "' style='margin-top: 5px; width: 206px'>")
                .data("column", columnDef)
                .bind("keyup", (e) => {
                    if (this.options.getFilterValues != null) {
                        this.options.getFilterValues(columnDef, (values: object[]) => {
                            if (values == null) {
                                values = this.getFilterValuesByInput($(e.target));
                            }
                            else {
                                var filter = this.containsFilter(columnDef, $(e.target).val());
                                values = values.filter(filter);
                            }

                            this.updateFilterInputs(menu, columnDef, values);
                        });
                    }
                    else
                        this.updateFilterInputs(menu, columnDef, this.getFilterValuesByInput($(e.target)));
                })
                .appendTo(menu);
        }

        private updateFilterInputs(menu: JQuery, columnDef: Slick.Column, filterItems: object[]) {
            var filterOptions = "<label><input type='checkbox' value='-1' />" +  
                (Q.tryGetText("Site.HeaderFiltersMixin.SelectAll") || "(Select All)") + "</label>";
            columnDef.filterValues = columnDef.filterValues || [];

            // WorkingFilters is a copy of the filters to enable apply/cancel behaviour
            this.workingFilters = columnDef.filterValues.slice(0);

            for (var i = 0; i < filterItems.length; i++) {
                var filtered = this.workingFilters.indexOf(filterItems[i]) >= 0;
                var text = this.getFilterText(columnDef, filterItems[i], true);
                filterOptions += "<label><input type='checkbox' value='" + i + "'"
                    + (filtered ? " checked='checked'" : "")
                    + "/>" + text + "</label>";
            }

            var $filter = menu.find('.filter');
            $filter.empty().append($(filterOptions));

            $(':checkbox', $filter).bind('click', e => {
                this.workingFilters = this.changeWorkingFilter(filterItems, this.workingFilters, $(e.target));
            });
        }

        private getFilterText(columnDef: Column, value: object, encode: boolean) {
            if (value == null)
                return (Q.tryGetText("Site.HeaderFiltersMixin.Null") || "(null)");

            if (this.options.useColumnFormatter && columnDef && columnDef.formatter) {
                try {
                    var obj = {};
                    obj[columnDef.field] = value;
                    return columnDef.formatter(-1, -1, value, columnDef, obj);
                }
                catch (ex) {
                }
            }
            
            return encode ? Q.htmlEncode(value) : ('' + value);
        }

        private showFilter(e: any) {
            var $menuButton = $(e.target);
            var columnDef = $menuButton.data("column");

            columnDef.filterValues = columnDef.filterValues || [];

            // WorkingFilters is a copy of the filters to enable apply/cancel behaviour
            this.workingFilters = columnDef.filterValues.slice(0);

            var internalShowFilter = () => {
                if (!this.menu) {
                    this.menu = $("<div class='slick-header-menu'>").appendTo(document.body);
                }

                this.menu.empty();

                this.addMenuInput(this.menu, columnDef);

                var filterOptions = "<label><input type='checkbox' value='-1' />" + 
                    (Q.tryGetText("Site.HeaderFiltersMixin.SelectAll") || "(Select All)") + "</label>";

                for (var i = 0; i < this.filterItems.length; i++) {
                    var filtered = this.workingFilters.indexOf(this.filterItems[i]) >= 0;
                    var text = this.getFilterText(columnDef, this.filterItems[i], true);

                    filterOptions += "<label><input type='checkbox' value='" + i + "'"
                                     + (filtered ? " checked='checked'" : "")
                                     + "/>" + text + "</label>";
                }

                var $filter = $("<div class='filter'>")
                               .append($(filterOptions))
                               .appendTo(this.menu);

                $('<button>' + (Q.tryGetText("Site.HeaderFiltersMixin.OkButton") || "OK") + '</button>')
                    .appendTo(this.menu)
                    .bind('click', ev => {
                        columnDef.filterValues = this.workingFilters.splice(0);
                        this.setButtonImage($menuButton, columnDef.filterValues.length > 0);
                        this.handleApply(ev, columnDef);
                    });

                $('<button>' + (Q.tryGetText("Site.HeaderFiltersMixin.ClearButton") || "Clear") + '</button>')
                    .appendTo(this.menu)
                    .bind('click', ev => {
                        columnDef.filterValues.length = 0;
                        this.setButtonImage($menuButton, false);
                        this.handleApply(ev, columnDef);
                    });

                $('<button>' + (Q.tryGetText("Site.HeaderFiltersMixin.CancelButton") || "Cancel") + '</button>')
                    .appendTo(this.menu)
                    .bind('click', e => this.hideMenu());

                $(':checkbox', $filter).bind('click', (e) => {
                    this.workingFilters = this.changeWorkingFilter(this.filterItems, this.workingFilters, $(e.target));
                });

                $filter.css('height', null);
                var menuHeight = this.menu.height();
                var buttonHeight = $(e.target).height();

                var offset = $(e.target).offset();
                var left = offset.left - this.menu.width() + $(e.target).width() - 8;

                var menuTop = offset.top + buttonHeight;

                var windowScrollTop = $(window).scrollTop();
                var bottomBoundary = $(window).height() + windowScrollTop;
                var contentWrapperTop = (parseInt($('div.content-wrapper').css('padding-top'), 10) || 0);

                if (menuTop + menuHeight > bottomBoundary &&
                    bottomBoundary - menuTop + contentWrapperTop < menuTop - windowScrollTop) {
                    menuTop -= (menuHeight + buttonHeight + 8);

                    if (menuTop < windowScrollTop)
                        menuTop = windowScrollTop;
                }

                var extraHeight = menuTop + menuHeight - bottomBoundary;

                if (extraHeight > 0) {
                    $filter.css('height', ($filter.height() - extraHeight));
                }

                this.menu.css("top", menuTop).css("left", (left > 0 ? left : 0));
            }

            var getFilterValuesDefault = () => {
                if (this.workingFilters.length === 0) {
                    // Filter based all available values
                    this.filterItems = this.getFilterValues((this.grid.getData() as any) as Slick.RemoteView<any>, columnDef);
                }
                else {
                    // Filter based on current dataView subset
                    this.filterItems = this.getAllFilterValues(
                        ((this.grid.getData() as any) as Slick.RemoteView<any>).getItems(), columnDef);
                }
            };

            if (this.options.getFilterValues != null) {
                this.options.getFilterValues(columnDef, (values: object[]) => {
                    if (values == null) {
                        getFilterValuesDefault();
                    }
                    else {
                        this.filterItems = values.slice(0);
                    }

                    internalShowFilter();
                });
            }
            else {            
                getFilterValuesDefault();
                internalShowFilter();
            }
        }

        private columnsResized() {
            this.hideMenu();
        }

        private changeWorkingFilter(filterItems: any[], workingFilters: any[], $checkbox: JQuery) {
            var value = $checkbox.val();
            var $filter = $checkbox.parent().parent();

            if ($checkbox.val() < 0) {
                // Select All
                if ($checkbox.prop('checked')) {
                    $(':checkbox', $filter).prop('checked', true);
                    workingFilters = filterItems.slice(0);
                } else {
                    $(':checkbox', $filter).prop('checked', false);
                    workingFilters.length = 0;
                }
            } else {
                var index = workingFilters.indexOf(filterItems[value]);

                if ($checkbox.prop('checked') && index < 0) {
                    workingFilters.push(filterItems[value]);
                }
                else {
                    if (index > -1) {
                        workingFilters.splice(index, 1);
                    }
                }
            }

            return workingFilters;
        }

        private setButtonImage($el: JQuery, filtered: boolean) {
            $el.toggleClass('is-filtered', filtered);
        }

        private handleApply(e: any, columnDef: Slick.Column) {
            this.hideMenu();

            this.onFilterApplied.notify({ 
                "grid": this.grid, 
                "column": columnDef 
            }, e, this);

            e.preventDefault();
            e.stopPropagation();
        }

        private getFilterValues(dataView: any, column: Slick.Column) {
            var seen = new window['Set']();
            var result = [];
            for (var i = 0; i < dataView.getLength() ; i++) {
                var value = dataView.getItem(i)[column.field];

                if (!seen.has(value)) {
                    seen.add(value);
                    result.push(value);
                }
            }

            return result.sort();
        }

        private containsFilter(column: Slick.Column, filter: string): ((value: any) => boolean) {
            if (filter == null && filter.length == 0)
                return v => true;

            var lowercaseFilter = filter.toString().toLowerCase();
            var useFormatter = column.formatter != null && this.options.useColumnFormatter;

            return (value: any) => {
                var text;
                if (useFormatter) {
                    text = this.getFilterText(column, value, false);
                    text = text.replace(/<[^>]+>/g, '');
                }
                else {
                    text = !value ? '' : value;
                }

                var lowercaseVal = text.toString().toLowerCase();
                return lowercaseVal.indexOf(lowercaseFilter) >= 0;
            };
        }

        private getFilterValuesByInput($input: JQuery) {
            var column = $input.data("column") as Column,
                filter = this.containsFilter(column, $input.val()),
                dataView = ((this.grid.getData() as any) as Slick.RemoteView<any>),
                seen = new window['Set'](), 
                result = [];

            for (var i = 0; i < dataView.getLength() ; i++) {
                var value = dataView.getItem(i)[column.field];
                if (!seen.has(value) && filter(value)) {
                    seen.add(value);
                    result.push(value);
                }
            }

            return result.sort();
        }

        private getAllFilterValues(data: any[], column: Slick.Column) {
            var seen = new window['Set'](), result = [];
            for (var i = 0; i < data.length; i++) {
                var value = data[i][column.field];

                if (!seen.has(value)) {
                    seen.add(value);
                    result.push(value);
                }
            }

            return result.sort();
        }

        private handleMenuItemClick(e: any) {
            var command = $(this).data("command");
            var columnDef = $(this).data("column");

            this.hideMenu();

            this.onCommand.notify({
                "grid": this,
                "column": columnDef,
                "command": command
            }, e, this);

            e.preventDefault();
            e.stopPropagation();
        }
    }
}